import {
  actions,
  getAllRolesAsync,
  addNewRoleAsync,
  getallroleclaimsAsync,
  getRolePermissionsAsync,
  updateRolePermissionsAsync,
  deletRolebyIdAsync,
} from './slices';

export const RolesActions = {
  ...actions,
  getAllRolesAsync,
  getallroleclaimsAsync,
  getRolePermissionsAsync,
  updateRolePermissionsAsync,
  deletRolebyIdAsync,
  addNewRoleAsync,
};
